<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'radarChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
        // colorArr:{
        //     type: Array | Object,
        //     default: function () {
        //         let colr = 
        //         return colr;
        //     }
        // }
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        barOption(){
            let that = this;
            let indicatorObj = [],data=[];
            let max = that.dataArray[0].value;
            that.dataArray.forEach(ele => {
                let tempObj = {};
                tempObj.name = ele.name;
                tempObj.max = max;
                indicatorObj.push(tempObj);
                data.push(ele.value);
            });
            
            var option = {
                tooltip: {
                  position: function(point, params, dom, rect, size) {
                        // 提示框位置
                        var x = 0; // x坐标位置
                        var y = 0; // y坐标位置
                        // 当前鼠标位置
                        var pointX = point[0];
                        var pointY = point[1];
                        // 提示框大小
                        var boxWidth = size.contentSize[0];
                        var boxHeight = size.contentSize[1];
                        // boxWidth > pointX 说明鼠标左边放不下提示框
                        if (boxWidth > pointX) {
                            x = 5;
                        } else {
                            // 左边放的下
                            x = pointX - boxWidth;
                        }
                        // boxHeight > pointY 说明鼠标上边放不下提示框
                        if (boxHeight > pointY) {
                            y = 5;
                        } else {
                            // 上边放得下
                            y = pointY - boxHeight;
                        }
                        return [x, y];
                    }  
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '下载',
                        }
                    }
                },
                radar: [
                    {	
                        name:{
                            textStyle:{
                                color:'#8a8a99'
                            }
                        },
                        splitArea : {
                            show : false
                        },
                        splitLine : {
                            lineStyle : {
                                width : 1,
                                color : '#ebebeb'
                            }
                        },
                        axisLine : {
                            lineStyle : {
                            color : '#ebebeb'
                            }
                        },
                        indicator: indicatorObj
                    }
                ],
                calculable: false,
                series: [
                    {
                        name: '热门主题词',
                        type: 'radar',
                        symbolSize:2,
                        label: {
                            show: false,
                            formatter: "{d}：{c}"
                        },
                        labelLine: {
                            show: true,
                            length: 10
                        },
                        color: '#2f9ff3',
                        areaStyle: {
                            color: 'rgba(47,159,243,0.3)'
                        },
                        //data: data
                        data:[{
                            value : data,
                            name : '热门主题词'
                        }]
                    }
                ]
            };
            return option;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.barOption());
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/radarChart.vue